const $1598339249cd3ecc$var$shopBtn = document.querySelectorAll(".shop__btn");
const $1598339249cd3ecc$var$shopItem = document.querySelectorAll(".shop-item");
let $1598339249cd3ecc$var$active = "shop__btn--active";
$1598339249cd3ecc$var$shopBtn.forEach((item)=>{
    item.addEventListener("click", ()=>{
        $1598339249cd3ecc$var$resetActiveBtn();
        $1598339249cd3ecc$var$showItem(item.id);
        item.classList.add("shop__btn--active");
    });
});
function $1598339249cd3ecc$var$resetActiveBtn() {
    $1598339249cd3ecc$var$shopBtn.forEach((item)=>{
        item.classList.remove("shop__btn--active");
    });
}
function $1598339249cd3ecc$var$showItem(newBtn) {
    $1598339249cd3ecc$var$active = newBtn;
    $1598339249cd3ecc$var$shopItem.forEach((item)=>{
        if (item.classList.contains($1598339249cd3ecc$var$active)) item.classList.remove("hide");
        else item.classList.add("hide");
    });
}


const $ca1c40e72736c660$var$header = document.querySelector("header");
window.addEventListener("scroll", $ca1c40e72736c660$var$windowScroll);
function $ca1c40e72736c660$var$windowScroll() {
    const distance = $ca1c40e72736c660$var$header.getBoundingClientRect().top + $ca1c40e72736c660$var$header.ownerDocument.defaultView.scrollY; // Get the distance between header and Y-coordinate (viewport)
    if (distance > 1) $ca1c40e72736c660$var$header.classList.add("header--scrolled");
    else $ca1c40e72736c660$var$header.classList.remove("header--scrolled");
}


const $e7902aff20e4e930$var$headerList = document.querySelector(".header__menu");
const $e7902aff20e4e930$var$headerBurger = document.querySelector(".header__burger");
const $e7902aff20e4e930$var$body = document.querySelector("body");
$e7902aff20e4e930$var$headerBurger.addEventListener("click", function(e) {
    e.preventDefault();
    $e7902aff20e4e930$var$headerList.classList.toggle("header__menu--active");
    $e7902aff20e4e930$var$headerBurger.classList.toggle("header__menu--active");
    $e7902aff20e4e930$var$body.classList.toggle("lock");
});




//# sourceMappingURL=index.a50001d1.js.map
